<div class="px-[10px] py-[15px]">
  <form>
    <label
      class="font-bold text-[#F94D00] mb-[10px] block md:text-[17px] text-[14px] leading-[20px]"
    >
      {{ slot?.widget?.data?.title }}
    </label>
    <div class="text-[14px]">
      @for (value of slot?.widget?.data?.values; track $index) {
        <div class="mb-[10px]">
          <input
            type="checkbox"
            [id]="$index + 1"
            [value]="value?.option"
            (change)="updateSelectedValues(value?.option, $event)"
          />
          <label [for]="$index + 1" class="ml-2 font-[500]">{{
            value?.option
          }}</label>
        </div>
      }
    </div>

    <label class="block mt-4 mb-[10px] md:text-[16px] text-[14px]">{{
      slot?.widget?.data?.subTitle
    }}</label>
    <textarea
      #additionalComments
      placeholder="Additional Comments"
      class="w-full p-2 border rounded h-[150px]"
    ></textarea>
  </form>
  <button
    class="inline-flex text-center whitespace-nowrap items-center justify-center gap-[8px] border border-solid border-[#F94D00] font-[600] text-[#162F4D] text-[12px] p-[22px] h-[40px] cursor-pointer rounded-full mt-[10px]"
    (click)="
      onActionCall(slot?.widget?.data?.action, additionalComments?.value)
    "
  >
    {{ slot?.widget?.data?.buttonTitle }}
  </button>
</div>
